import { createSlide } from "../../slidesOps/createSlide";
export function slideEvents(data) {
    if (!data) {
        return;
    }
    const countPerPage = 6;
    const title = data.title;
    const items = data.parsedItems;
    if (!items.length) {
        return;
    }
    let html = "";
    let itemCount = 0;
    html += `
    <div class="informer">
        <h2 class="informer__headline text-color">${title}</h2>
        <hr class="fragment fade-right" data-autoslide="500" data-fragment-index="0" />
        <div class="r-stack fragment fade-out" data-autoslide="500">
    `;
    for (let i = 0, l = items.length; i < l; i++) {
        itemCount++;
        const item = items[i];
        let autoslide = 2000;
        if (i % countPerPage === 0) {
            itemCount += countPerPage;
            if (items.length > 0) {
                // first item of any page but the first page
                html += `</li></ul>`;
            }
            html += `<ul><li>`;
        }
        if (((i + 1) % countPerPage === 0 && i > 0) || i === items.length - 1) {
            autoslide =
                (12000 / countPerPage) *
                    ((i + 1) % countPerPage || countPerPage) +
                    4000; // items.length
        }
        html += `
            </li>
            <li class="fragment fade-right text-color" data-autoslide="${autoslide}" data-fragment-index="${itemCount}">
                <div class="fragment fade-out" data-autoslide="100" data-fragment-index="${itemCount + countPerPage}">
                    ${item.originText}
                </div>
            </li>
            <li>
        `;
    }
    html += `
                    </li>
                </ul>
            </div>
        </div>
    `;
    createSlide({
        autoslide: 150,
        center: "false",
        html: html,
        wrap: "false",
        background: { color: null },
    }, "event-list");
}
